import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { DropdownItem } from 'reactstrap';
import { useIntl } from 'react-intl';

import ImporterIcon from './Importer/Icon';

import { showIntercomWidget } from '../helpers';

const UploadButtonImporters = ({
  history,
  location,
  profile,
  openImportModal,
}) => {
  const intl = useIntl();

  if (!(profile.importers && profile.importers.length > 0)) {
    return null;
  }

  const handleOpenImportModal = (e) => {
    const serviceId = e.target.getAttribute('data-service-id');
    const urlParams = new URLSearchParams(location.search);
    urlParams.append('importer', serviceId);
    history.replace(`${location.pathname}?${urlParams.toString()}`);
    showIntercomWidget();

    openImportModal(serviceId);
  };

  return (
    <>
      <DropdownItem className="importers-header" header>
        {intl.formatMessage({ defaultMessage: 'Import from' })}
      </DropdownItem>
      <DropdownItem divider />
      {profile.importers.map(importer => (
        <DropdownItem
          key={importer.id}
          data-service-id={importer.id}
          onClick={handleOpenImportModal}
        >
          <ImporterIcon importer={importer} />
          {importer.name}
        </DropdownItem>
      ))}
    </>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

UploadButtonImporters.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  openImportModal: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps)(UploadButtonImporters));
